<form [formGroup]="incomeForm()">
  <h2>Min ekonomi</h2>
  <p>Var kommer pengarna ifrån och vilket belopp vill du sätta in på ditt
    sparande hos oss det närmaste året?</p>

  <div
    [class.selection-error]="incomeForm().errors?.['atLeastOneRequired'] && incomeForm().touched"
  >
    <div class="column">
      @for (option of savingsAccountService.incomeOptions; track $index) {
        <mat-checkbox
          id="checkbox-{{option.value}}"
          #checkbox
          [checked]="option.checked"
          (change)="onCheckboxChange($index, $event.checked, option.value)"
          (keydown.enter)="onCheckboxChange($index, !checkbox.checked, option.value); $event.preventDefault()"
          [attr.aria-controls]="option.checked ? 'input-' + option.value : null"
        >
          {{ option.label }}
        </mat-checkbox>

        @if (option.checked) {
          <mat-form-field
            [class.small-screen]="orientationService.isSmallScreen()"
            [style.margin-top.rem]="0.5"
          >
            <mat-label>Årligt belopp i SEK (efter skatt)</mat-label>
            <input
              placeholder="Årligt belopp i SEK (efter skatt)"
              maxlength="16"
              id="input-{{option.value}}"
              inputmode="numeric"
              spbFormatNumber
              [formControlName]="option.value"
              matInput
              type="text"
              [attr.aria-labelledby]="'checkbox-' + option.value">

            @if (incomeForm().get(option.value)?.invalid && incomeForm().get(option.value)?.touched) {
              <mat-icon matIconSuffix aria-hidden="true">
                priority_high
              </mat-icon>
            }

            @if (incomeForm().get(option.value)?.touched) {
              <mat-error>
                Vänligen ange ett belopp
              </mat-error>
            }
          </mat-form-field>
        }
      }

      @if (incomeForm().errors?.['atLeastOneRequired'] && incomeForm().touched) {
        <div class="mat-error-container">
          <mat-icon class="negative" aria-hidden="true">priority_high</mat-icon>
          <mat-error>Du måste välja minst en inkomstkälla</mat-error>
        </div>
      }
    </div>
  </div>
</form>
